/* unplugin-vue-components disabled */const { ref, computed, onBeforeMount } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-ad670cca"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "top-bar" };
const _hoisted_2 = { class: "left-wrap" };
const _hoisted_3 = {
    key: 0,
    class: "logo"
};
const _hoisted_4 = _withScopeId(() => (0, vue_2.createElementVNode)("div", { class: "image" }, null, -1));
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = { style: { "display": "flex", "justify-content": "center", "align-items": "center" } };
const _hoisted_7 = { class: "el-dropdown-link" };
const _hoisted_8 = { class: "el-tag el-tag--light" };
const _hoisted_9 = { truncated: true };
const _hoisted_10 = { class: "right-wrap" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "user-info-wrap" };
const _hoisted_13 = { class: "username" };
const index_vue_1 = tslib_1.__importDefault(require("@/components/SvgIcon/index.vue"));
const work_1 = require("@/store/modules/work");
const laborer_1 = require("@/store/modules/laborer");
const model_1 = require("@/model");
const project_1 = require("@/service/project");
const one_message_1 = require("@/utils/one_message");
const user_1 = require("@/service/user");
const W_jpg_1 = tslib_1.__importDefault(require("@/assets/avatar/W.jpg"));
const loading_1 = require("@/utils/loading");
const user_2 = require("@/service/user");
const router_1 = tslib_1.__importDefault(require("@/router"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TopBar',
    emits: ['openProject', 'delProject', 'copyProject', 'openProjectCfgs'],
    setup(__props, { emit: __emit }) {
        const laborerStore = (0, laborer_1.useLaborer)();
        const userInfo = ref();
        const username = computed(() => { var _a; return (_a = userInfo.value) === null || _a === void 0 ? void 0 : _a.nickName; });
        const avatar = computed(() => {
            var _a;
            if (userInfo.value) {
                return `data:image/png;base64,${(_a = userInfo.value) === null || _a === void 0 ? void 0 : _a.avatar}`;
            }
            return W_jpg_1.default;
        });
        const emit = __emit;
        const workStore = (0, work_1.useWork)();
        const curProject = computed(() => model_1.Project.current());
        const selectMode = ref(workStore.selectMode);
        const autoSaveTips = computed(() => {
            switch (workStore.projectSaveState) {
                case 'saved':
                    return '已保存';
                case 'saving':
                    return '保存中';
                case 'changed':
                    return '已改动';
                case 'error':
                    return '保存到云端失败，请检查网络';
                default:
                    return '';
            }
        });
        const isLaborerPage = computed(() => router_1.default.currentRoute.value.name === 'laborer');
        const hasPerm = computed(() => {
            var _a, _b;
            return (((_a = userInfo.value) === null || _a === void 0 ? void 0 : _a.perms) || []).includes("app:ide:page:design") ||
                (((_b = userInfo.value) === null || _b === void 0 ? void 0 : _b.perms) || []).includes("app:ide:page:program");
        });
        const robotConfigDialog = ref();
        function deleteProject(e) {
            var _a;
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let project = model_1.Project.current();
                try {
                    yield project_1.ProjectService.current().delProject(project.project_id);
                    (0, one_message_1.oneMessage)({ message: "删除成功", type: 'success' });
                    emit('delProject');
                    emit('openProject');
                    (_a = robotConfigDialog.value) === null || _a === void 0 ? void 0 : _a.openRobotConfig();
                }
                catch (e) {
                    console.error(e);
                    (0, one_message_1.oneMessage)({ message: '删除失败', type: 'error' });
                }
            });
        }
        function handleProjectCommand(command) {
            if (command === 'copy') {
                emit('copyProject');
            }
        }
        function handleUserCommand(command) {
            if (laborerStore.isRobotMoving) {
                (0, one_message_1.oneMessage)({ message: '与机器人交互中，请停止后重试！', type: 'warning' });
                return;
            }
            switch (command) {
                case 'logout':
                    handleLogout();
                    break;
            }
        }
        function onBreadBtnClick() {
            if (laborerStore.isRobotMoving) {
                (0, one_message_1.oneMessage)({ message: '与机器人交互中，请停止后重试！', type: 'warning' });
                return;
            }
            emit('openProject');
        }
        function openUserProfile() {
        }
        function handleOpenOriginal() {
            if (laborerStore.isRobotMoving) {
                (0, one_message_1.oneMessage)({ message: '与机器人交互中，请停止后重试！', type: 'warning' });
                return;
            }
            router_1.default.push({ name: 'program' });
        }
        let isLogouting = false;
        function handleLogout() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    (0, loading_1.openLoading)();
                    if (isLogouting)
                        return;
                    isLogouting = true;
                    yield (0, user_1.logout)();
                }
                catch (e) {
                    console.error(e);
                }
                finally {
                    isLogouting = false;
                    (0, loading_1.closeLoading)();
                }
            });
        }
        onBeforeMount(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            userInfo.value = yield (0, user_2.getUserInfo)();
        }));
        return (_ctx, _cache) => {
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_breadcrumb_item = (0, vue_2.resolveComponent)("el-breadcrumb-item");
            const _component_arrow_down = (0, vue_2.resolveComponent)("arrow-down");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_el_dropdown_item = (0, vue_2.resolveComponent)("el-dropdown-item");
            const _component_el_dropdown_menu = (0, vue_2.resolveComponent)("el-dropdown-menu");
            const _component_el_popconfirm = (0, vue_2.resolveComponent)("el-popconfirm");
            const _component_el_dropdown = (0, vue_2.resolveComponent)("el-dropdown");
            const _component_el_text = (0, vue_2.resolveComponent)("el-text");
            const _component_el_tag = (0, vue_2.resolveComponent)("el-tag");
            const _component_el_breadcrumb = (0, vue_2.resolveComponent)("el-breadcrumb");
            const _component_el_radio_button = (0, vue_2.resolveComponent)("el-radio-button");
            const _component_el_radio_group = (0, vue_2.resolveComponent)("el-radio-group");
            const _component_el_avatar = (0, vue_2.resolveComponent)("el-avatar");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.unref)(isLaborerPage))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, _hoisted_5))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(_component_el_breadcrumb, { separator: "/" }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_breadcrumb_item, null, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_el_button, {
                                        onClick: onBreadBtnClick,
                                        size: "small"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(isLaborerPage) ? '我的工位' : '我的项目'), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            false
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_breadcrumb_item, { key: 0 }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                            (0, vue_2.createVNode)(_component_el_dropdown, {
                                                trigger: "click",
                                                "hide-on-click": false,
                                                onCommand: handleProjectCommand
                                            }, {
                                                dropdown: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        (0, vue_2.createVNode)(_component_el_dropdown_menu, null, {
                                                            default: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createVNode)(_component_el_dropdown_item, { command: "copy" }, {
                                                                    default: (0, vue_2.withCtx)(() => [
                                                                        (0, vue_2.createTextVNode)("复制项目")
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        (0, vue_2.createVNode)(_component_el_popconfirm, {
                                                            title: "此操作将永久删除, 是否继续?",
                                                            "confirm-button-text": "删除",
                                                            "cancel-button-text": "取消",
                                                            "confirm-button-type": "danger",
                                                            onConfirm: deleteProject
                                                        }, {
                                                            reference: (0, vue_2.withCtx)(() => [
                                                                (!(0, vue_2.unref)(isLaborerPage))
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_dropdown_menu, { key: 0 }, {
                                                                        default: (0, vue_2.withCtx)(() => [
                                                                            (0, vue_2.createVNode)(_component_el_dropdown_item, { command: "del" }, {
                                                                                default: (0, vue_2.withCtx)(() => [
                                                                                    (0, vue_2.createTextVNode)("删除项目")
                                                                                ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                        _: 1
                                                                    }))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ]),
                                                            _: 1
                                                        })
                                                    ])
                                                ]),
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_7, [
                                                        (0, vue_2.createElementVNode)("span", _hoisted_8, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_9, (0, vue_2.toDisplayString)(((0, vue_2.unref)(curProject) || { name: "" }).name), 1),
                                                            (0, vue_2.createVNode)(_component_el_icon, { class: "el-icon--right" }, {
                                                                default: (0, vue_2.withCtx)(() => [
                                                                    (0, vue_2.createVNode)(_component_arrow_down)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ])
                                                    ])
                                                ]),
                                                _: 1
                                            }),
                                            (0, vue_2.createVNode)(_component_el_text, {
                                                size: "small",
                                                tag: "sub",
                                                class: "auto-save-tips"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(autoSaveTips)), 1)
                                                ]),
                                                _: 1
                                            })
                                        ])
                                    ]),
                                    _: 1
                                }))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createVNode)(_component_el_breadcrumb_item, null, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_el_tag, null, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(((0, vue_2.unref)(curProject) || { name: "" }).name), 1)
                                        ]),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_text, {
                                        size: "small",
                                        tag: "sub",
                                        class: "auto-save-tips"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(autoSaveTips)), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                false
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_radio_group, {
                        key: 0,
                        modelValue: (0, vue_2.unref)(selectMode),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(selectMode) ? (selectMode).value = $event : null))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(['normal', 'point', 'line', 'area', 'part', 'cord'], (select) => {
                                return (0, vue_2.createVNode)(_component_el_radio_button, {
                                    disabled: "",
                                    key: 'select-' + select,
                                    label: select
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_el_icon, {
                                            size: (0, vue_2.unref)(selectMode) == select ? '20px' : '16px'
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(index_vue_1.default, {
                                                    class: "icon",
                                                    "icon-class": 'select-' + select
                                                }, null, 8, ["icon-class"])
                                            ]),
                                            _: 2
                                        }, 1032, ["size"])
                                    ]),
                                    _: 2
                                }, 1032, ["label"]);
                            }), 64))
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                    ((0, vue_2.unref)(hasPerm) && (0, vue_2.unref)(isLaborerPage))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                onClick: handleOpenOriginal
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("打开原项目")
                                ]),
                                _: 1
                            })
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(_component_el_dropdown, {
                        trigger: "click",
                        onCommand: handleUserCommand
                    }, {
                        dropdown: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_dropdown_item, { command: "logout" }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("退出登录")
                                ]),
                                _: 1
                            })
                        ]),
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                (0, vue_2.createVNode)(_component_el_avatar, {
                                    size: 32,
                                    "src-set": (0, vue_2.unref)(avatar),
                                    onClick: openUserProfile
                                }, null, 8, ["src-set"]),
                                (0, vue_2.createElementVNode)("span", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(username)), 1)
                            ])
                        ]),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
